/*
 * Keeps the PDP progress teaser (gosh-pdp-progress-teaser.liquid) in sync with the live cart
 * after add-to-cart, without a page reload. The teaser isn't part of the cart-drawer section,
 * so Shopify's built-in cart section re-render never touches it — this script is what makes it
 * "dynamic" instead of a snapshot from page load.
 *
 * Money is formatted with a simple cents -> "X,XX €" formatter matching this store's
 * Bulgarian/EUR display convention used elsewhere on the site, rather than depending on
 * Shopify.formatMoney (not guaranteed to be loaded on every template).
 */
(function () {
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  function init(root) {
    if (root.dataset.goshTeaserInit) return;
    root.dataset.goshTeaserInit = 'true';

    var promoIds = (root.dataset.promoProductIds || '')
      .split(',')
      .filter(Boolean)
      .map(function (id) {
        return id.trim();
      });

    var shippingThreshold = parseInt(root.dataset.shippingThreshold, 10) || 0;
    var gift70Threshold = parseInt(root.dataset.gift70Threshold, 10) || 0;
    var gift100Threshold = parseInt(root.dataset.gift100Threshold, 10) || 0;
    var gift70Value = parseInt(root.dataset.gift70Value, 10) || 0;
    var gift100Value = parseInt(root.dataset.gift100Value, 10) || 0;
    var productInPromo = root.dataset.productInPromo === 'true';

    var promoTextEl = root.querySelector('[data-teaser-text="promo"]');
    var giftTextEl = root.querySelector('[data-teaser-text="gift"]');

    function render(cartTotalCents, promoEligibleQty) {
      if (promoTextEl && productInPromo) {
        var parity = promoEligibleQty % 2;
        promoTextEl.innerHTML =
          parity === 1
            ? '<strong>Добави този продукт</strong> в количката → -10% на всеки 2-ри продукт, автоматично!'
            : 'Добави още <strong>1 продукт</strong> след този → -10% на всеки 2-ри продукт от количката';
      }

      if (giftTextEl) {
        var html;
        if (cartTotalCents >= gift100Threshold) {
          html =
            'Печелиш и подарък на стойност до ' + formatMoney(gift100Value) + ' — вече е в количката ти!';
        } else if (cartTotalCents >= gift70Threshold) {
          html =
            'Остават <strong>' +
            formatMoney(gift100Threshold - cartTotalCents) +
            '</strong> до подарък на стойност ' +
            formatMoney(gift100Value);
        } else if (cartTotalCents > 0) {
          html =
            'Остават <strong>' +
            formatMoney(gift70Threshold - cartTotalCents) +
            '</strong> до безплатен подарък на стойност до ' +
            formatMoney(gift70Value);
        } else {
          html =
            'Поръчай над ' + formatMoney(gift70Threshold) + ' за безплатен подарък на стойност до ' + formatMoney(gift70Value);
        }
        giftTextEl.innerHTML = html;
      }
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var eligibleQty = 0;
          (cart.items || []).forEach(function (item) {
            if (promoIds.indexOf(String(item.product_id)) !== -1) {
              eligibleQty += item.quantity;
            }
          });
          render(cart.total_price, eligibleQty);
        })
        .catch(function () {
          /* leave server-rendered state as-is on failure */
        });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-gosh-pdp-teaser]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
